import React from 'react'
import { connect } from 'react-redux'
import Title from '../components/Title.jsx'

const logos = [
    {
        img: '/images/ico/valamar.jpg',
        link: 'https://valamar.com'
    },
    {
        img: '/images/ico/laguna.jpg',
        link: 'https://lagunaporec.com'
    },
    {
        img: '/images/ico/maistra.jpg',
        link: 'https://www.maistra.com/'
    }
]

const PartnersContainer = (props) => {
    const items = logos.map((val, key) => (
        <a
            key={key}
            href={val.link}
            target="_blank"
            rel="nooperner noreferrer"
        >
            <img
                className="partners-container__item"
                src={val.img}
            />
        </a>
    ))

    return (
        <div className="section-spacing">
            <Title
                className="header1--center"
                title={props.langData.partnersTitle}
            />
            <div className="partners-container">
                {items}
            </div>
        </div>
    )
}

const mapStateToProps = state => ({
    langData: state.langData.references
})

export default connect(mapStateToProps)(PartnersContainer)



// WEBPACK FOOTER //
// ./src/scripts/containers/PartnersContainer.jsx